<template>
  <div v-if="user" class="grid-x grid-padding-x">
    <div class="cell large-6 medium-6 small-12">
      <md-field :class="getValidationClass('firstName')">
        <label>Vorname</label>
        <md-input name="first-name" id="first-name" autocomplete="off" v-model="user.firstName"
                  :disabled="sending"/>
        <span class="md-error" v-if="!$v.user.firstName.required">Vorname ist notwendig</span>
        <span class="md-error" v-else-if="!$v.user.firstName.minlength">Ungültiger Vorname</span>
      </md-field>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <md-field :class="getValidationClass('lastName')">
        <label>Nachname</label>
        <md-input name="last-name" id="last-name" autocomplete="off" v-model="user.lastName"
                  :disabled="sending"/>
        <span class="md-error" v-if="!$v.user.lastName.required">Nachname ist notwendig</span>
        <span class="md-error" v-else-if="!$v.user.lastName.minlength">Ungültiger Nachname</span>
      </md-field>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <md-field :class="getValidationClass('email')">
        <label>Email</label>
        <md-input type="email" name="email" id="email" autocomplete="off" v-model="user.email"
                  :disabled="sending || (mode === 'update' && !isSage)"/>
        <span class="md-error" v-if="!$v.user.email.required">Email-Adresse ist notwendig</span>
        <span class="md-error" v-else-if="!$v.user.email.email">Ungültige Email-Adresse</span>
      </md-field>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <md-field :class="getValidationClass('rolesProfile')">
        <label>Benutzer-Profil</label>
        <md-select v-model="user.rolesProfile" autocomplete="off" id="user-profiles"
                   :disabled="sending || (mode === 'update' && !(isSage || isAdmin))">
          <md-option v-for="profile of availableProfiles" :value="profile" :key="profile">
            {{ labels.rolesprofile[profile] }}
          </md-option>
        </md-select>
        <span class="md-error" v-if="!$v.user.rolesProfile.required">Benutzer-Profil ist notwendig</span>
      </md-field>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <md-field v-if="mode !== 'update'" :class="getValidationClass('initialpw')">
        <div class="grid-x" style="width: 100%">
          <div class="cell small-12 medium-12 large-4 text-left">
            <label>Passwort
              <span v-if="passwordScore !== null && passwordScore < 3" style="color: orange; font-size: 12px;"><br>Passwort zu schwach</span>
            </label>
          </div>
          <div class="cell small-12 medium-12 large-8 text-right">
            <password id="initial-pw" v-model="user.initialpw" :toggle="true"
                      :secureLength="webAppSettings.pwdSecureLength" @score="showPasswordScore" style="max-width: 100%;"
                      :disabled="sending"/>
          </div>
        </div>
        <span class="md-error" v-if="invalidPassword && user.initialpw.length === 0">Passwort ist notwendig</span>
        <span class="md-error" v-if="!$v.user.initialpw.password && mode !== 'update' && user.initialpw.length > 0">Passwort muss min. {{
            webAppSettings.pwdSecureLength
          }} Zeichen lang sein</span>
      </md-field>
      <md-field v-else :class="getValidationClass('initialpw')">
        <div class="grid-x" style="width: 100%">
          <div class="cell small-12 medium-12 large-4 text-left">
            <label>Neues Passwort
              <span v-if="passwordNewScore !== null && passwordNewScore < 3"
                    style="color: orange; font-size: 12px;"><br>Passwort zu schwach</span>
            </label>
            <md-tooltip md-direction="top">Hier kann optional ein neues Passwort angeben werden.</md-tooltip>
          </div>
          <div class="cell small-12 medium-12 large-8 text-right">
            <password id="change-pw" v-model="user.initialpw" :toggle="true"
                      :secureLength="webAppSettings.pwdSecureLength" @score="showpasswordNewScore"
                      style="max-width: 100%;" :disabled="sending"/>
          </div>
        </div>
        <span class="md-error" v-if="!$v.user.initialpw.password && mode === 'update' && user.initialpw.length > 0">Passwort muss min. {{
            webAppSettings.pwdSecureLength
          }} Zeichen lang sein</span>
      </md-field>
    </div>
    <div v-if="!user.sage" class="cell large-6 medium-6 small-12">
      <md-field :class="getValidationClass('allowedFacilities')">
        <label>Zugewiesene Einrichtungen</label>
        <md-select v-model="user.allowedFacilities" autocomplete="off" id="allowed-facilities"
                   :disabled="sending || (!(isSage || isAdmin))" multiple>
          <md-option v-for="facility of availableFacilities" :value="facility.referenceNumber"
                     :key="facility.referenceNumber">
            {{ facility.name }}
          </md-option>
        </md-select>
        <span class="md-error"
              v-if="!$v.user.allowedFacilities.required">Mindestens eine Einrichtung ist notwendig</span>
      </md-field>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <div class="grid-x grid-padding-x">
        <div class="cell large-6 medium-6 small-12">
          <label :class="checkBoxWarningClass(!user.dsgvoConfirmationObtained)">Einwilligung Datenverarbeitung</label>
          <md-switch class="md-primary" v-model="user.dsgvoConfirmationObtained">
            <p :class="booleanText(user.dsgvoConfirmationObtained)">{{
                booleanText(user.dsgvoConfirmationObtained)
              }}</p>
          </md-switch>
          <md-tooltip>
            <div v-if="!user.dsgvoConfirmationObtained">
              Die Einwilligung gemäß Datenschutz-Grundverordnung (Art. 6 DSGVO) zur Verarbeitung dieser
              personenbezogenen
              Daten muss
              seitens <b>{{ user.firstName }} {{ user.lastName }}</b> schriftlich gegeben sein.
            </div>
          </md-tooltip>
        </div>
        <div class="cell large-6 medium-6 small-12">
          <label class="small-label">Benutzer aktiv</label>
          <md-switch class="md-primary" v-model="user.active"
                     :disabled="sending || (!(isSage || isAdmin)) || (user.username === currentUser.username)">
            <p>{{ booleanText(user.active) }}</p>
          </md-switch>
        </div>
      </div>
    </div>
    <div class="cell large-6 medium-6 small-12">
      <div v-if="user.username === currentUser.username && isBeta" class="grid-x grid-padding-x">
        <div class="cell large-6 medium-12 small-12">
          <label :class="checkBoxWarningClass(!twoFactorAuthSwitchActive)">Zwei-Faktor-Authentifizierung (2FA)</label>
          <md-switch class="md-primary" v-model="twoFactorAuthSwitchActive" @change="on2faActivation">
            <p :class="booleanText(twoFactorAuthSwitchActive)">{{ booleanText(twoFactorAuthSwitchActive) }}</p>
          </md-switch>
          <md-tooltip>
            <div v-if="!twoFactorAuthSwitchActive">
              Die Zwei-Faktor-Authentifizierung (2FA) ist ein zusätzlicher Sicherheitsschritt, der neben dem
              Passwort einen zweiten, unabhängigen Nachweis verlangt, um sich bei einem Dienst anzumelden.
              Typische Methoden sind Codes per SMS, Push-Benachrichtigungen, Fingerabdrücke oder Apps.
              <br><br>
              Für <b>SoSE</b> können Sie z.B. die <b>Google Authenticator</b> oder eine vergleichbare App verwenden.
            </div>
          </md-tooltip>

          <div v-if="!user.twoFactorAuthActiv && twoFactorAuthSwitchActive && qrCodeImage">
            <br>
            <label><b>2FA Aktivierungsanleitung</b></label><br>
            <label class="small-label">
              <i>1) Installieren Sie eine <b>OTP Authenticator App</b> auf Ihrem Gerät (Smartphone, Tablet, Laptop).</i><br>
              <i>2) Starten Sie die <b>OTP Authenticator App</b> und scannen damit den QR-Code.</i><br>
              <i>3) Geben Sie den 6-stelling Code aus der <b>Authenticator</b> App in das Feld <b>One Time
                Password</b> ein.</i><br>
              <i>4) Klicken Sie auf den Button <b>2FA aktivieren</b>.</i><br>
              <br><br>
            </label>
          </div>

          <div v-if="user.twoFactorAuthActiv && twoFactorAuthSwitchActive && qrCodeImage">
            <br>
            <label><b>Weiteres Gerät für 2FA nutzen</b></label><br>
            <label class="small-label">
              <i>1) Installieren Sie eine <b>OTP Authenticator App</b> auf Ihrem zusätzlichen Gerät (Smartphone, Tablet, Laptop).</i><br>
              <i>2) Starten Sie die <b>OTP Authenticator App</b> und scannen damit den QR-Code.</i><br>
              <br>
              <i>Da die <b>Zwei-Faktor-Authentifizierung (2FA)</b> für ihr Benutzer-Konto bereits aktiv ist, kann das neue Gerät sofort ohne weitere Bestätigung für 2FA genutzt werden.</i>
              <br>
            </label>
          </div>

        </div>
        <div class="cell large-6 medium-12 small-12">
          <div v-if="!user.twoFactorAuthActiv && !qrCodeImage && sending">
            <br><br>
            <md-progress-bar md-mode="indeterminate"/>
          </div>
          <div v-if="!user.twoFactorAuthActiv && twoFactorAuthSwitchActive && qrCodeImage">
            <label class="small-label">QR-Code
              <md-tooltip>
                Bitte scannen Sie den QR-Code mit der Kamera Ihres Smartphones.
              </md-tooltip>
            </label>
            <br>
            <img v-if="qrCodeImage" :src="qrCodeImage" class="medium">
            <br><br><br>
          </div>

          <div v-if="user.twoFactorAuthActiv">
            <label>Zwei-Faktor-Authentifizierung (2FA) <b>aktiviert</b>.</label>
            <br>
            <img v-if="qrCodeImage" :src="qrCodeImage" class="medium">
            <br><br><br>
          </div>

          <div v-if="twoFactorAuthSwitchActive">
            <md-field :class="get2FAValidationClass()">
              <label><b>One Time Password</b> (OTP)</label>
              <md-input name="one-time-password" id="one-time-password-id" autocomplete="off"
                        v-model="confirmation2faOTP"
                        :disabled="sending"/>
              <span class="md-error" v-if="validateConfirmation2faOTP.required">One Time Password ist notwendig</span>
              <span class="md-error" v-else-if="validateConfirmation2faOTP.minLength">One Time Password muss mindestens 6 Zeichen sein</span>
            </md-field>
            <br>

            <div v-if="sending" style="margin-bottom: 4rem">
              <md-progress-bar md-mode="indeterminate"/>
            </div>

            <div v-if="!user.twoFactorAuthActiv">
              <button v-if="!sending" class="button archive" type="submit" @click="finish2fa">
                <i class="fi-shield"></i>&nbsp;&nbsp;&nbsp;2FA aktivieren
              </button>
            </div>
            <div v-else>
              <button v-if="!sending" class="button alert" type="submit" @click="deactivate2fa">
                <i class="fi-shield"></i>&nbsp;&nbsp;&nbsp;2FA deaktivieren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSage" class="cell large-3 medium-3 small-3">
      <label class="small-label">Beta-User</label>
      <md-switch class="md-primary" v-model="user.beta" :disabled="sending || !isSage">
        <p>{{ booleanText(user.beta) }}</p>
      </md-switch>
    </div>
  </div>
</template>

<script>

import {validationMixin} from 'vuelidate'
import {
  required,
  minLength,
  email,
} from 'vuelidate/lib/validators'
import jQuery from "jquery";
import Password from 'vue-password-strength-meter'
import UserService from "@/services/UserService";
import HttpErrorHandler from "@/services/HttpErrorHandler";

export default {
  name: 'UserForm',
  mixins: [validationMixin],

  components: {Password},

  props: {
    user: {
      required: true
    },
    sending: {
      required: true
    },
    mode: {
      required: true,
    },
    availableProfiles: {
      required: true
    },
    availableCustomerNo: {
      required: true
    },
    availableCustomerNos: {
      required: true
    },
    availableFacilities: {
      required: true
    }
  },

  data: () => ({
    invalid: true,
    invalidPassword: false,
    passwordScore: null,
    passwordNewScore: null,

    twoFactorAuthSwitchActive: false,
    qrCodeImage: null,
    confirmation2faOTP: '',

    validateConfirmation2faOTP: {
      required: false,
      minLength: false,
      invalid: false,
      dirty: false,
    }
  }),

  created() {
    this.twoFactorAuthSwitchActive = this.user.twoFactorAuthActiv;
    if (this.user.twoFactorAuthActiv) {
      this.getQRCode();
    }
  },

  beforeDestroy() {
    this.init2faInputSyncHandler(false);
  },

  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(3)
      },
      lastName: {
        required,
        minLength: minLength(3)
      },
      rolesProfile: {
        required,
      },
      email: {
        required,
        email,
      },
      initialpw: {
        minLength: minLength(8)
      },
      customerNo: {
        required,
        minLength: minLength(9)
      },
      allowedFacilities: {},
    },
  },

  methods: {

    init2faInputSyncHandler(init) {
      if (init) {
        setTimeout(() => {
          jQuery('#one-time-password-id').bind('keyup', () => {
            this.confirmation2faOTP = jQuery('#one-time-password-id').val();
            this.validate2fa();
          });
        }, 500);
      } else {
        jQuery('#one-time-password-id').unbind('keyup');
      }
    },

    finish2fa() {
      this.validateConfirmation2faOTP.dirty = true;
      this.validate2fa();

      if (this.validateConfirmation2faOTP.required === false && this.validateConfirmation2faOTP.invalid === false && this.validateConfirmation2faOTP.minLength === false) {
        this.sending = true;

        setTimeout(() => {
          UserService.finish2fa(this.confirmation2faOTP)
              .then(() => {
                this.sending = false;
                this.$store.commit('successMsg', 'Die Zwei-Faktor-Authentifizierung (2FA) für Benutzer <b>'
                    + this.user.username + '</b> wurde erfolgreich aktiviert.');
                this.$emit("updateUserSuccess");
              })
              .catch(e => {
                this.sending = false;
                HttpErrorHandler.handleError(e, this, 'Fehler beim Aktivieren der Zwei-Faktor-Authentifizierung (2FA)');
              })
        }, 500);
      }
    },

    deactivate2fa() {
      this.validateConfirmation2faOTP.dirty = true;
      this.validate2fa();

      if (this.validateConfirmation2faOTP.required === false && this.validateConfirmation2faOTP.invalid === false && this.validateConfirmation2faOTP.minLength === false) {
        this.sending = true;

        setTimeout(() => {
          UserService.deactivate2fa(this.confirmation2faOTP)
              .then(() => {
                this.sending = false;
                this.$store.commit('successMsg', 'Die Zwei-Faktor-Authentifizierung (2FA) für Benutzer <b>'
                    + this.user.username + '</b> wurde erfolgreich deaktiviert.');
                this.$emit("updateUserSuccess");
              })
              .catch(e => {
                this.sending = false;
                HttpErrorHandler.handleError(e, this, 'Fehler beim Deaktivieren der Zwei-Faktor-Authentifizierung (2FA)');
              })
        }, 500);
      }
    },

    createImageFromBlob(image) {
      let reader = new FileReader();
      reader.addEventListener('load', () => {
        this.qrCodeImage = reader.result;
      }, false);
      if (image) {
        reader.readAsDataURL(image);
      }
    },

    on2faActivation() {
      if (this.user.twoFactorAuthActiv === false) {
        this.prepareQRCode();
      } else {
        this.twoFactorAuthSwitchActive = true;
        this.deactivate2fa();
      }
    },

    prepareQRCode() {
      this.qrCodeImage = null;

      this.validateConfirmation2faOTP.required = false;
      this.validateConfirmation2faOTP.invalid = false;
      this.validateConfirmation2faOTP.minLength = false;
      this.validateConfirmation2faOTP.dirty = false;

      if (this.twoFactorAuthSwitchActive) {
        this.sending = true;
        UserService.prepare2fa()
            .then(() => {
              this.getQRCode();
            })
            .catch(e => {
              HttpErrorHandler.handleError(e, this, 'Fehler beim Einrichten der Zwei-Faktor-Authentifizierung (2FA)');
              this.sending = false;
            })
      }
    },

    getQRCode() {
      this.qrCodeImage = null;
      UserService.get2faQRCode()
          .then(QRCodeResponse => {
            this.createImageFromBlob(QRCodeResponse.data);

            this.sending = false;
            this.twoFactorAuthSwitchActive = true;
            this.init2faInputSyncHandler(this.twoFactorAuthSwitchActive);
          })
          .catch(e => {
            HttpErrorHandler.handleError(e, this, 'Fehler beim Laden des 2FA QR-Codes');
            this.sending = false;
          })
    },

    showPasswordScore(score) {
      this.passwordScore = score;
    },

    showpasswordNewScore(score) {
      this.passwordNewScore = score;
    },

    onOpenOrganizationSelector() {
      setTimeout(() => jQuery('.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content').css('max-width', '500px'), 50);
    },

    get2FAValidationClass() {
      return {
        'md-invalid': this.validateConfirmation2faOTP.invalid && this.validateConfirmation2faOTP.dirty
      }
    },

    getValidationClass(fieldName) {
      let field = this.$v.user[fieldName];

      if (field && fieldName === 'allowedFacilities' && this.mode !== 'create' && this.user.allowedFacilities.length <= 0) {
        return {
          'md-invalid': field.$dirty
        }
      }

      if (field && fieldName === 'initialpw' && this.mode !== 'update' && this.user.initialpw.length === 0) {
        return {
          'md-invalid': field.$dirty
        }
      }

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },

    validate2fa() {
      this.validateConfirmation2faOTP.required = false;
      this.validateConfirmation2faOTP.invalid = false;
      this.validateConfirmation2faOTP.minLength = false;

      if (this.confirmation2faOTP.length <= 0) {
        this.validateConfirmation2faOTP.required = true;
        this.validateConfirmation2faOTP.invalid = true;
      }

      if (this.confirmation2faOTP.length > 0 && this.confirmation2faOTP.length < 6) {
        this.validateConfirmation2faOTP.minLength = true;
        this.validateConfirmation2faOTP.invalid = true;
      }
    },

    validateUser() {
      this.$v.$touch();

      this.invalid = this.$v.$invalid;
      if (this.mode !== 'update' && this.user.initialpw === '') {
        this.invalid = true;
        this.invalidPassword = true;
      }

      if (this.mode === 'update' && this.user.allowedFacilities.length <= 0 && this.isSage && this.invalid === false) {
        this.invalid = true;
      }

      if (this.user.allowedFacilities.length <= 0 && !this.isSage && this.invalid === false) {
        this.invalid = true;
      }
    },

    booleanText(value) {
      return value ? 'ja' : 'nein';
    },

    checkBoxWarningClass(warn) {
      return warn ? 'small-label cb-warn' : 'small-label';
    },
  },

  computed: {
    webAppSettings() {
      return this.$store.getters.webAppSettings
    },

    isAdmin() {
      return this.$store.getters.admin
    },

    isSage() {
      return this.$store.getters.sage
    },

    labels() {
      return this.$store.getters.labels
    },

    currentUser() {
      return this.$store.getters.user;
    },

    isBeta() {
      return this.$store.getters.beta;
    },
  },
};
</script>

<style lang="scss" scoped>

.ja {
  color: forestgreen;
  font-weight: bold;
  font-size: larger;
}

.nein {
  color: red;
  font-weight: bold;
  font-size: larger;
}

.md-tooltip {
  font-size: medium;
  height: auto;
  width: auto;
  max-width: 300px;
  white-space: normal;
}

.cb-warn {
  color: red;
  font-weight: bold;
}

.medium {
  width: 200px;
  border-radius: 18px
}
</style>
